import { css } from '@emotion/react'
import { StyleSelector } from 'components/styles/primitives/modifiers/types'

export const ifHovered: StyleSelector = style => css`
	&:hover {
		${style};
	}
`
